import axios from 'axios';
import baseUrl from './common';

/**
 * auth - 获取用户权限
 * method get
 */
const auth = () => axios({
    url: `${baseUrl}/api/user/products`,
    method: 'get',
});

export default auth;
